<template>
  <div v-if="bubbleContent" class="container">
    {{ bubbleContent }}
  </div>
</template>

<script>
export default {
  name: 'BubbleV2',
  props: {
    bubbleContent: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 6px 12px;
  border-radius: 6px 18px 6px 18px;
  background: #31b77e;
  font-family: DiDiSans-Pro-Bold;
  font-size: 20px;
  color: #fff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: left;
}
</style>
